import type React from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { NavBarBackground } from '../NavBar.h'
import type { INavBar } from './../NavBar'

import { useEffect, useState } from 'react'
import { NavBarBackgroundOverlay } from '../NavBar.h'
import { MenuOverlay, MobileMenuSC, ToggleInput } from './MobileMenu.styled'
import { ToggleIcon } from './ToggleIcon'

export interface IMobileMenu {
  children?: React.ReactNode | React.ReactNode[]
  width?: number
  height?: number
  color?: TextBoxColors
  background?: NavBarBackground
  backgroundOverlay?: NavBarBackgroundOverlay
  resetCheckedKey?: INavBar['resetCheckedKey']
  isEmpty?: INavBar['isEmpty']
}

export const MobileMenu = ({
  children,
  width = 296,
  color,
  height = 56,
  background,
  backgroundOverlay = NavBarBackgroundOverlay.Default,
  resetCheckedKey,
  isEmpty,
}: IMobileMenu) => {
  const [checked, setChecked] = useState(false)
  const toggleVisible = () => {
    setChecked(!checked)
  }
  useEffect(() => {
    setChecked(false)
  }, [
    resetCheckedKey,
    typeof document !== 'undefined' && typeof window !== 'undefined'
      ? window.location.href
      : undefined,
  ])

  return (
    <MobileMenuSC
      backgroundOverlay={backgroundOverlay}
      colorDefault={color}
      width={width}
      height={height}
      background={background}
    >
      <ToggleInput
        type={'checkbox'}
        checked={checked}
        onChange={toggleVisible}
        disabled={isEmpty}
      />
      {children}
      {checked && <MenuOverlay onClick={toggleVisible} />}
      <ToggleIcon />
    </MobileMenuSC>
  )
}
